import React from 'react';
import './PageHeader.css';

/**
 * Content header: page title + optional actions.
 * Logo is shown in the main navbar only.
 * Children (e.g. "+ New Client" button) render to the right of the title.
 */
function PageHeader({ title, children }) {
  return (
    <div className="page-header">
      <h1 className="page-header-title">{title}</h1>
      {children && <div className="page-header-actions">{children}</div>}
    </div>
  );
}

export default PageHeader;
